import React, {useEffect} from "react";
import {Card, CardActionArea, CardContent, CardMedia, Grid, GridList, Typography, CardActions,Button} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Animation from '../Components/animation';
import Aos from 'aos';
import "aos/dist/aos.css";

//Import Project Images

import Skygit from '../Images/skygit.svg';
import Metoza from '../Images/metoza.svg';
import Covidapp from '../Images/covidapp.svg';
import Mask from '../Images/mask.svg';
import Analyzer from '../Images/c19analyzer.svg';
import Gsap from '../Images/gsap.svg';

const useStyles=makeStyles((themes)=>({

    container:{
        textAlign:"center",
        
    },

    grayboard:{
        backgroundColor:"rgb(58, 110, 165)",
        paddingBottom:"60px",
        borderRadius:"10px",
        overflow: "hidden",
        position: "relative",
        
    },
    topic:{
        fontSize:"30px",
        paddingTop:"30px",
        margin:"auto",
        paddingBottom:"100px",
        color:"white",

        [themes.breakpoints.down('xs')]: {
            paddingBottom:"50px",
           },
    },

    gridlist:{
        height:"500px",
        width:"100%",
        textAlign:"center",
     
        
        [themes.breakpoints.down('xs')]: {
            paddingTop:"20px"
           },

        [themes.breakpoints.up('md')]: {
            paddingTop:"50px",
            height:"600px",
            width:"90%"
           },
    },
    projectcontainer:{
        textAlign:"center",
        height:"500px",
        backgroundColor:"rgb(58, 110, 165)",
 

    },
    project:{
        backgroundColor:"white",
        width:"80%",
        margin:"auto",

        [themes.breakpoints.down('xs')]: {
           width:"87%",
           float:"right"
          },

        
    },



    // Inside the card
    media:{
        height:"250px",

        [themes.breakpoints.up('md')]: {
            height:"300px"
           },
    },
    button1:{
        color:"white",
        backgroundColor:"rgba(22,33,90,255)",
        '&:hover':{
            backgroundColor:"rgb(235, 235, 235)",
            color:"black"   
        }


    },
    button2:{
        color:"rgba(22,33,90,255)",
        backgroundColor:"rgb(235, 235, 235)"
    },
    teck:{
        textAlign:"left"
    }

}))

export default function Projects(){

    const classes =useStyles();

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])


    return(
        <div id="projects">
            <Grid container className={classes.container}>

            <Grid item  md={1}></Grid>

            <Grid item xs={12} md={10}>
                <Grid container className={classes.grayboard}>
                    <Grid item xs={12} md={12} ><Typography className={classes.topic}>Projects</Typography></Grid>

                    <Grid item xs={12} md={4} >
                        <Animation></Animation>
                    </Grid>


                    <Grid item xs={12} md={8}>
                        <GridList cols={1} className={classes.gridlist} cellHeight={500} spacing={50}>


                        <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={12} data-aos="fade-up">
                                    <CardActionArea>
                                        <CardMedia image={Skygit} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Sky - Git
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                A web Application to present github stats of GitHub users.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • React
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Material-UI
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Github API
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" color="primary" className={classes.button1} href="https://sky-git.vercel.app">
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/vae97/Git-Profile">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>

                            <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={12} >
                                    <CardActionArea>
                                        <CardMedia image={Metoza} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Metoza
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                A web Application that shows the current weather forecast for a given city.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • React
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • React Bootstrap
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Open Weather API
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" color="primary" className={classes.button1} href="https://metoza.vercel.app">
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/vae97/WeatherApp">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>

                  
                            <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={12}>
                                    <CardActionArea>
                                        <CardMedia image={Covidapp} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Covid-19 Web App
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                A web Application to present COVID-19 analytics in Sri Lanka and Other Countries.
                                                I built Front-End and Animations.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • React
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Materialize
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • ApexCharts
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" color="primary" className={classes.button1} href="https://sl-covid-app.supunhd96.vercel.app">
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/SupunHD96/SLCovidApp">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>

                            <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={5}>
                                    <CardActionArea>
                                        <CardMedia image={Mask} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Face Mask Detector
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                               An application written in python with OpenCV to detect face mask.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Python
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • OpenCV
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" color="primary" className={classes.button1} href="https://dev.to/vae97/face-mask-detector-28cm"> 
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/vae97/Face-Mask-Detector">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>


                            <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={5}>
                                    <CardActionArea>
                                        <CardMedia image={Analyzer} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                C-19 Analyzer
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                              A software written for windows operating system that shows covid-19 analytics.
                                              This Application is based on Covid-19 Web App.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Node Js
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Electron Js
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • CSS
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" variant="contained"  disabled={true}> 
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/vae97/C-19-Analyzer">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>

                            <div className={classes.projectcontainer}>
                                <Card className={classes.project} elevation={5}>
                                    <CardActionArea>
                                        <CardMedia image={Gsap} title="Project1" className={classes.media}></CardMedia>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                React-GSAP-Animations
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                               This is a simple web app to show different GSAP animation techniques with React.
                                            </Typography>
                                            <div className={classes.teck}>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • React
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • Material UI
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                  • GSAP
                                                </Typography>
                                            </div>
                                        </CardContent>
                                        
                                    </CardActionArea>
                                    <CardActions>
                                    <Button size="small" variant="contained"  disabled={true}> 
                                        Visit
                                    </Button>
                                    <Button size="small" color="primary" className={classes.button2} href="https://github.com/vae97/React-GSAP-Animations">
                                        Code
                                    </Button>
                                </CardActions>
                                </Card>
                            </div>


                



                    </GridList>
                    </Grid>

                </Grid>
            </Grid>

            <Grid item  md={1}></Grid>

                
        

            </Grid>
        </div>
    )
}

